import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

// 🎯 القطعة القابلة لإعادة الاستخدام لميزة "الفلاتر المفضلة" - أي شاشة
// ليست تقدر تستخدمها بمجرد ما تبعتلها appName بتاعها (زي "WORKORDER")
// من غير ما تعرف تفاصيل الـ API. الحفظ/الحذف بيعملوا reload تلقائي
export function useFavoriteFilters(appName) {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(false);

  const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  const reload = useCallback(async () => {
    if (!appName) return;
    setLoading(true);
    try {
      const res = await axios.get('/api/favorite-filters', {
        params: { app_name: appName },
        headers: authHeaders()
      });
      setFavorites(res.data || []);
    } catch (err) {
      console.error('Failed to load favorite filters', err);
    } finally {
      setLoading(false);
    }
  }, [appName]);

  useEffect(() => { reload(); }, [reload]);

  const saveFavorite = async (name, filtersObj) => {
    if (!name || !name.trim()) {
      toast.error('Please enter a name for this favorite filter');
      return false;
    }
    try {
      await axios.post('/api/favorite-filters', {
        app_name: appName,
        name: name.trim(),
        filters: filtersObj
      }, { headers: authHeaders() });
      toast.success('Favorite filter saved');
      await reload();
      return true;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to save favorite filter');
      return false;
    }
  };

  const deleteFavorite = async (id) => {
    try {
      await axios.delete(`/api/favorite-filters/${id}`, { headers: authHeaders() });
      await reload();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to delete favorite filter');
    }
  };

  return { favorites, loading, saveFavorite, deleteFavorite, reload };
}

export default useFavoriteFilters;
